import { render, staticRenderFns } from "./agent-entry.vue?vue&type=template&id=85c774e8&scoped=true"
import script from "./agent-entry.vue?vue&type=script&lang=js"
export * from "./agent-entry.vue?vue&type=script&lang=js"
import style0 from "./agent-entry.vue?vue&type=style&index=0&id=85c774e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c774e8",
  null
  
)

export default component.exports